import React from 'react'

const InnerCardHeader = ({name}) => {
    return (
        <div className="bg-gray-600 border-1 border-bottom border-light-dark p-4">
            <h6 className="font-weight-bold m-0 text-white">{name}</h6>
        </div>
    )
}

export default InnerCardHeader